import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Nueva Factura
    createInvoice: {},
    optionsDocumentClassCreateInvoice: [],
    optionsCorrectiveMethodsCreateInvoice: [],
    optionsCorrectiveReasonsCreateInvoice: [],
    optionsBuyersCreateInvoice: [],
    optionsServicesEnabled: [],
    optionsNewInvoiceBuyer: [],
    optionsNewInvoiceSeller: [],
    optionsInvoiceLineTax: [],
    optionsFilterDocumentTypeByFormat: [],

    // Flag que nos indican si se puede autocompletar
    isBuyerFilterable: true,
    isSellerFilterable: true
  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Lineas de factura
    isShowDescripcionLineaFactura: true,
    isShowCodigoArticuloLineaFactura: true,
    isShowCodigoArticuloSellerLineaFactura: false,
    isShowCodigoArticuloBuyerLineaFactura: false,
    isShowCantidadLineaFactura: true,
    isShowPrecioNetoLineaFactura: true,
    isShowCosteTotalLineaFactura: true
  }
  return local
}
function setByUserLocalCreate () {
  const local = {
    // Columnas Tabla Lineas de factura
    isShowDescripcionLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowDescripcionLineaFactura,
    isShowCodigoArticuloLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowCodigoArticuloLineaFactura,
    isShowCodigoArticuloSellerLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowCodigoArticuloSellerLineaFactura,
    isShowCodigoArticuloBuyerLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowCodigoArticuloBuyerLineaFactura,
    isShowCantidadLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowCantidadLineaFactura,
    isShowPrecioNetoLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowPrecioNetoLineaFactura,
    isShowCosteTotalLineaFactura: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionFactura.isShowCosteTotalLineaFactura
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Lineas de factura
    isShowDescripcionLineaFactura: true,
    isShowCodigoArticuloLineaFactura: true,
    isShowCodigoArticuloSellerLineaFactura: false,
    isShowCodigoArticuloBuyerLineaFactura: false,
    isShowCantidadLineaFactura: true,
    isShowPrecioNetoLineaFactura: true,
    isShowCosteTotalLineaFactura: true
  },
  session: initSession()
}

// getters
const getters = {
  // Columnas Tabla Líneas de factura
  isShowDescripcionLineaFactura: state => {
    return state.local.isShowDescripcionLineaFactura
  },
  isShowCodigoArticuloLineaFactura: state => {
    return state.local.isShowCodigoArticuloLineaFactura
  },
  isShowCodigoArticuloSellerLineaFactura: state => {
    return state.local.isShowCodigoArticuloSellerLineaFactura
  },
  isShowCodigoArticuloBuyerLineaFactura: state => {
    return state.local.isShowCodigoArticuloBuyerLineaFactura
  },
  isShowCantidadLineaFactura: state => {
    return state.local.isShowCantidadLineaFactura
  },
  isShowPrecioNetoLineaFactura: state => {
    return state.local.isShowPrecioNetoLineaFactura
  },
  isShowCosteTotalLineaFactura: state => {
    return state.local.isShowCosteTotalLineaFactura
  },

  // Nueva Factura
  createInvoice: state => {
    return state.session.createInvoice
  },
  // Combos
  optionsDocumentClassCreateInvoice: state => {
    return state.session.optionsDocumentClassCreateInvoice
  },
  optionsCorrectiveMethodsCreateInvoice: state => {
    return state.session.optionsCorrectiveMethodsCreateInvoice
  },
  optionsCorrectiveReasonsCreateInvoice: state => {
    return state.session.optionsCorrectiveReasonsCreateInvoice
  },
  optionsBuyersCreateInvoice: state => {
    return state.session.optionsBuyersCreateInvoice
  },
  // FLAG
  isBuyerFilterable: state => {
    return state.session.isBuyerFilterable
  },
  isSellerFilterable: state => {
    return state.session.isSellerFilterable
  },
  optionsServicesEnabled: state => {
    return state.session.optionsServicesEnabled
  },
  optionsNewInvoiceBuyer: state => {
    return state.session.optionsNewInvoiceBuyer
  },
  optionsNewInvoiceSeller: state => {
    return state.session.optionsNewInvoiceSeller
  },
  optionsInvoiceLineTax: state => {
    return state.session.optionsInvoiceLineTax
  },
  optionsFilterDocumentTypeByFormat: state => {
    return state.local.optionsFilterDocumentTypeByFormat
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameCreate ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCreate()
    }
  },
  isNewVersionCreacionFacturaLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.creacionFactura)
  },
  // Método para obtener la cabecera de una factura
  async getInvoiceHeader ({
    commit, rootState
  }, idInvoice) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoice/' + idInvoice,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para obtener la cabecera de una factura a través de un pedido
  async getInvoiceHeaderByOrder ({
    commit, rootState
  }, idOrder) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoice/order/' + idOrder,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          orderId: idOrder
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 

  // Método para obtener la cabecera de una factura a través de un pedido
  async getInvoiceHeaderByDeliveryNote ({
    commit, rootState
  }, deliveryId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoice/deliverynote/' + deliveryId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          deliveryId: deliveryId
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 

  // Método para obtener la cabecera de una factura a través de varias recepciones
  async getInvoiceHeaderByRecadvs ({
    commit, rootState
  }, idRecadv) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoice/recadvlist',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          recadvId: idRecadv
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },  

    // Método para obtener la cabecera de una factura rectificativa a través de una factura prcesada
    async getInvoiceHeaderByInvoice ({
      commit, rootState
    }, inv) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/invoice/invoicerectificative',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            invoiceId: inv
          },
          paramsSerializer: params => {
            return qs.stringify(params, {
              indices: false
            })
          }
        })
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },  
  
  // Método para obtener los tipos de extensión de las facturas
  async getOptionsExtensionTypeInvoice ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/extensiontype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para previsualizar pdf de una factura en creacion
     * @param {*} draftId
    */
  async previewDraftPdf ({
    commit, state
  }, draftId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: 'draft/' + draftId + '/pdf',
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'factura.pdf'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
     * Servicio para previsualizar el xml de una factura en creacion
     * @param {*} draftId
    */
  async previewDraftXml ({
    commit, state
  }, draftId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + draftId + '/xml',
        responseType: 'blob'
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'factura.xml'
      const fileGroup = /([^;]+;[ ]+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup && fileGroup[2]) {
        filename = fileGroup[2]
      }
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
    * Servicio para visualizar una factura con xsl
    * @param {*} params
    */
  async visualizeDraftWithXsl ({ commit, state }, draftId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/draft/' + draftId + '/xsl'
      })

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para llenar Select de roles para una empresa vendedora o compradora
   */
  async getOptionsRoleCentre ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/centrerole',
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para crear o actualizar una factura
  async saveInvoice ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/invoice/create',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getDocumentClassesByFormatAndType ({
    commit, rootState
  }, data) {
    try {
      if (data.query.idRecadv == null) {
        data.query.idRecadv = ''
      }

      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoice/documentclasses',
        params: data.query
      })

      const documnetClass = response.data
      commit('OPTIONS_DOCUMENTCLASS_CI_STATE', documnetClass)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return documnetClass
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para obtener la informacion de una extension asociada a una factura
  async getInvoiceExtension ({
    commit, rootState
  }, invoiceId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoiceextension/' + invoiceId + '/extension'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async saveExtensionInvoice ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoiceextension/save/' + data.invoiceId + '/' + data.extensionTypeId,
        data: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getOptionsRoleCentreFaceB2b ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoiceextension/faceb2b/roles'
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener todas las líneas de factura
   * dado el identificador de una factura.
   */
  async getInvoiceLines ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoiceline/all',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para validar todas las líneas de factura
   * dado el identificador de una factura.
   */
  async validateInvoiceLines ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoiceline/validate',
        params: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para llenar Select de
   * Documento de factura dado el formato.
   */
  async getOptionsInvoiceDocumentByFormat ({
    commit, rootState
  }, dat) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/document/' + dat.id + "/" + dat.idProject+ "/" + dat.cab,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsInvoiceDocumentByFormat = response.data

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsInvoiceDocumentByFormat
    } catch (error) {
      console.log('ERROR getOptionsInvoiceDocumentByFormat --- ', error.response)
      throw error.response
    }
  },

    /**
   * Servicio para llenar Select de
   * Documento de factura dado el formato.
   */
    async getOptionsInvoiceDocumentProjectConfig ({
      commit, rootState
    }, dat) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/constant/documentProjectConfig/' + dat.idProject,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })
  
        const documentProjectConf = response.data
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return documentProjectConf
      } catch (error) {
        console.log('ERROR getOptionsInvoiceDocumentByFormat --- ', error.response)
        throw error.response
      }
    },

  /**
   * Servicio para llenar Select de tipos de
   * Impuestos en líneas de Facturas
   */
  async getOptionsInvoiceLineTax ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoiceline/taxes/' + data.formatDocumentId + '/' + data.id,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          rate: 1
        }
      })

      const optionsInvoiceLinesTax = response.data
      commit('OPTIONS_INVOICE_LINE_TAX_STATE', optionsInvoiceLinesTax)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsInvoiceLinesTax
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
   * Servicio para llenar Select de tipos de
   * Impuestos en líneas de Facturas con rate 0
   */
  async getOptionsInvoiceLineTaxCero ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoiceline/taxes/' + data.formatDocumentId + '/' + data.id,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          rate: 0
        }
      })

      const optionsInvoiceLinesTax = response.data
      commit('OPTIONS_INVOICE_LINE_TAX_STATE', optionsInvoiceLinesTax)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsInvoiceLinesTax
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },


  /**
   * Servicio para obtener la lista completa de entradas de la tabla tax_legal_tax
   */
  async getOptionsInvoiceLineLegalTax ({
    commit, rootState
  },data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/legaltax/'+data.taxId+'/'+data.id+'/'+data.taxableEvent,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
   * Servicio para actualizar o crear una línea de factura
   */
  async updateInvoiceLine ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/invoiceline/update',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: data.id,
          idInvoice: data.idInvoice,
          description: data.description,
          articleCode: data.articleCode,
          articleCodeSeller: data.articleCodeSeller,
          articleCodeBuyer: data.articleCodeBuyer,
          quantity: data.quantity,
          netPrice: data.netPrice,
          unitOfMeasureId: data.unitOfMeasureId,
          additionalData: data.additionalData,
          goodsCode: data.goodsCode,
          weight: data.weight,
          listDocuments: data.listDocuments,
          listTaxes: data.listTaxes,
          createNewInvoiceLine: data.createNewInvoiceLine
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
   * Servicio para obtener una determinada línea de factura
   */
  async getInvoiceLine ({
    commit, rootState
  }, invoiceLineId) {
    if(invoiceLineId){
      try {
        const response = await axios({
          method: 'GET',
          url: '/invoiceline/' + invoiceLineId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    } else {
      console.log('ERROR getInvoiceLine:: No invoiceLineId')  
    }
  },

  /**
   * Servicio para eliminar una determinada línea de factura
   */
  async deleteInvoiceLine ({
    commit, rootState
  }, params) {
      try {
        const response = await axios({
          method: 'DELETE',
          url: '/invoiceline',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            invoiceLineId: params.invoiceLineId
          },
          paramsSerializer: params => {
            return qs.stringify(params, {
              indices: false
            })
          }
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
  },

  /**
   * Servicio para recalcular los totales de borrador de factura
   */
  async recalculateInvoiceTotals ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoicetotals/recalculate',
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    /**
   * Servicio para obtener PaymentMeans Iban
   */
    async getPaymentMeansIban ({
      commit, rootState
    }, data) {
      try {
        const response = await axios({
          method: 'GET',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/invoicetotals/paymentMeansIban/'+data.invoiceId,
          params: data,
          paramsSerializer: params => {
            return qs.stringify(params, {
              indices: false
            })
          }
        })
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

  /**
   * Servicio para enviar el borrador de factura
   */
  async sendInvoice ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/invoicetotals/send',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para obtener los totales de una factura dado su ID
  async getInvoiceTotalsById ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoicetotals/tot',
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    // Método para obtener los irpf del proyecto
    async getOptionsIrpfRate ({
      commit, rootState
    }, data) {
      try {
        const response = await axios({
          method: 'GET',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/invoicetotals/irpf/'+data.idProject,
          params: data,
          paramsSerializer: params => {
            return qs.stringify(params, {
              indices: false
            })
          }
        })
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

  // Método para guardar un vencimiento de una factura
  async saveInstallment ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoicetotals/' + data.invoiceId + '/installment',
        data: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para borrar un vencimiento de una factura
  async deleteInstallment ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/invoicetotals/installment/delete',
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener el origen del borrador
   */
  async getInvoiceObject ({
    commit, rootState
  }, invoiceId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/invoice/' + invoiceId + '/sourceObjectInvoice',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 

  /**
     * Servicio para obtener las opciones de método de rectificación
     * dado el id de formato de documento
     */
  async getOptionsCorrectiveMethodsByFormat ({
    commit, state
  }, id) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/correctivemethod/' + id
      })

      const correctiveMethods = response.data
      commit('OPTIONS_CORRECTMETHODS_CI_STATE', correctiveMethods)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return correctiveMethods
    } catch (error) {
      console.log('ERROR getOptionsCorrectiveMethodsByFormat --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para obtener las opciones de razones de rectificación
     * dado el id de formato de documento
     */
  async getOptionsCorrectiveReasonByFormat ({
    commit, state
  }, id) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/correctivereason/' + id
      })

      const correctiveReasons = response.data
      commit('OPTIONS_REASONSMETHOD_CI_STATE', correctiveReasons)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return correctiveReasons
    } catch (error) {
      console.log('ERROR getOptionsCorrectiveReasonByFormat --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Tipo de
     * Documento dado el formato.
     */
  async getOptionsDocumentTypeByFormat ({
    commit, rootState
  }, id) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype/' + id,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      const optionsFilterDocumentTypeByFormat = response.data
      commit('OPTIONS_FILTER_DOCUMENT_TYPE_BY_FORMAT_STATE', optionsFilterDocumentTypeByFormat)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return optionsFilterDocumentTypeByFormat
    } catch (error) {
      console.log('ERROR getOptionsDocumentTypeByFormat --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de media-type
     */
  async getOptionsUnitsOfMeasure ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/measure',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select Filtro de hechos imponibles
     */
  async getOptionInvoiceLineTaxableEvent ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/taxableEvent',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
     * Servicio para llenar Select de métodos de pago
     */
  async getOptionsPaymentMeans ({
    commit, rootState
  }, formatDocumentId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/paymentmeans',
        params: {
          formatDocumentId: formatDocumentId
        },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Columnas Tabla Lineas de factura
  isShowDescripcionLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DESCRIPCION_LINEA_FACTURA', payload)
  },
  isShowCodigoArticuloLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_ARTICULO_LINEA_FACTURA', payload)
  },
  isShowCodigoArticuloSellerLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_ARTICULO_SELLER_LINEA_FACTURA', payload)
  },
  isShowCodigoArticuloBuyerLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_ARTICULO_BUYER_LINEA_FACTURA', payload)
  },
  isShowCantidadLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CANTIDAD_LINEA_FACTURA', payload)
  },
  isShowPrecioNetoLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_PRECIO_NETO_LINEA_FACTURA', payload)
  },
  isShowCosteTotalLineaFacturaAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_COSTE_TOTAL_LINEA_FACTURA', payload)
  },

  // Nueva Factura
  createInvoiceState: ({
    commit
  }, payload) => {
    commit('CREATE_INVOICE_STATE', payload)
  },
  optionsDocumentClassCreateInvoiceState: ({
    commit
  }, payload) => {
    commit('OPTIONS_DOCUMENTCLASS_CI_STATE', payload)
  },
  optionsCorrectiveMethodsCreateInvoiceState: ({
    commit
  }, payload) => {
    commit('OPTIONS_CORRECTMETHODS_CI_STATE', payload)
  },
  optionsCorrectiveReasonsCreateInvoiceState: ({
    commit
  }, payload) => {
    commit('OPTIONS_REASONSMETHOD_CI_STATE', payload)
  },
  optionsBuyersCreateInvoiceState: ({
    commit
  }, payload) => {
    commit('OPTIONS_BUYER_CI_STATE', payload)
  },
  isBuyerFilterableState: ({
    commit
  }, payload) => {
    commit('BUYER_FILTERABLE_STATE', payload)
  },
  isSellerFilterableState: ({
    commit
  }, payload) => {
    commit('SELLER_FILTERABLE_STATE', payload)
  },
  optionsServicesEnabledState: ({
    commit
  }, payload) => {
    commit('OPTIONS_SERVICES_ENABLED_STATE', payload)
  },
  optionsNewInvoiceBuyerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_NEW_INVOICE_BUYER_STATE', payload)
  },
  optionsNewInvoiceSellerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_NEW_INVOICE_SELLER_STATE', payload)
  },
  optionsInvoiceLineTaxState: ({
    commit
  }, payload) => {
    commit('OPTIONS_INVOICE_LINE_TAX_STATE')
  },
  optionsFilterDocumentTypeByFormatState: ({
    commit
  }, payload) => {
    commit('OPTIONS_FILTER_DOCUMENT_TYPE_BY_FORMAT_STATE', payload)
  }
}

// mutations
const mutations = {
  resetSessionCreacionFactura (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Columnas Tabla Lineas de factura
  'IS_SHOW_DESCRIPCION_LINEA_FACTURA' (state, payload) {
    state.local.isShowDescripcionLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowDescripcionLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_ARTICULO_LINEA_FACTURA' (state, payload) {
    state.local.isShowCodigoArticuloLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowCodigoArticuloLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_ARTICULO_SELLER_LINEA_FACTURA' (state, payload) {
    state.local.isShowCodigoArticuloSellerLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowCodigoArticuloSellerLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_ARTICULO_BUYER_LINEA_FACTURA' (state, payload) {
    state.local.isShowCodigoArticuloBuyerLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowCodigoArticuloBuyerLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CANTIDAD_LINEA_FACTURA' (state, payload) {
    state.local.isShowCantidadLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowCantidadLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PRECIO_NETO_LINEA_FACTURA' (state, payload) {
    state.local.isShowPrecioNetoLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowPrecioNetoLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COSTE_TOTAL_LINEA_FACTURA' (state, payload) {
    state.local.isShowCosteTotalLineaFactura = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionFactura.isShowCosteTotalLineaFactura = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Nueva Factura
  'CREATE_INVOICE_STATE' (state, payload) {
    state.session.createInvoice = payload
  },
  'OPTIONS_DOCUMENTCLASS_CI_STATE' (state, payload) {
    state.session.optionsDocumentClassCreateInvoice = payload
  },
  'OPTIONS_CORRECTMETHODS_CI_STATE' (state, payload) {
    state.session.optionsCorrectiveMethodsCreateInvoice = payload
  },
  'OPTIONS_REASONSMETHOD_CI_STATE' (state, payload) {
    state.session.optionsCorrectiveReasonsCreateInvoice = payload
  },
  'OPTIONS_BUYER_CI_STATE' (state, payload) {
    state.session.optionsBuyersCreateInvoice = payload
  },
  'BUYER_FILTERABLE_STATE' (state, payload) {
    state.session.isBuyerFilterable = payload
  },
  'SELLER_FILTERABLE_STATE' (state, payload) {
    state.session.isSellerFilterable = payload
  },
  'OPTIONS_SERVICES_ENABLED_STATE' (state, payload) {
    state.session.optionsServicesEnabled = payload
  },
  'OPTIONS_NEW_INVOICE_BUYER_STATE' (state, payload) {
    state.session.optionsNewInvoiceBuyer = payload
  },
  'OPTIONS_NEW_INVOICE_SELLER_STATE' (state, payload) {
    state.session.optionsNewInvoiceSeller = payload
  },
  'OPTIONS_INVOICE_LINE_TAX_STATE' (state, payload) {
    state.session.optionsInvoiceLineTax = payload
  },
  'OPTIONS_FILTER_DOCUMENT_TYPE_BY_FORMAT_STATE' (state, payload) {
    state.local.optionsFilterDocumentTypeByFormat = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
